export default{

    suggestions: state => {
        return state.suggestions
    }
}